/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum PermissionSearchOrderBy {
    Name = 'Name',
    Description = 'Description',
    ApplicationName = 'ApplicationName'
}


export function instanceOfPermissionSearchOrderBy(value: any): boolean {
    for (const key in PermissionSearchOrderBy) {
        if (Object.prototype.hasOwnProperty.call(PermissionSearchOrderBy, key)) {
            if (PermissionSearchOrderBy[key as keyof typeof PermissionSearchOrderBy] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PermissionSearchOrderByFromJSON(json: any): PermissionSearchOrderBy {
    return PermissionSearchOrderByFromJSONTyped(json, false);
}

export function PermissionSearchOrderByFromJSONTyped(json: any, ignoreDiscriminator: boolean): PermissionSearchOrderBy {
    return json as PermissionSearchOrderBy;
}

export function PermissionSearchOrderByToJSON(value?: PermissionSearchOrderBy | null): any {
    return value as any;
}

export function PermissionSearchOrderByToJSONTyped(value: any, ignoreDiscriminator: boolean): PermissionSearchOrderBy {
    return value as PermissionSearchOrderBy;
}

